import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { TestAutomationCase } from '../Models/test-automation-case.model';
import { Observable } from 'rxjs';
import { Literals } from '../literals';

@Injectable({
  providedIn: 'root'
})
export class TestAutomationService {

  constructor(private rest: RestService) { }

  getProjectTestCasesData(projectId: string) {
    return this.rest.get('getProjectTestCasesData', projectId);
  }

  getProjectTestCaseCategories(projectId: string) {
    return this.rest.get('getProjectTestCaseCategories', projectId);
  }

  saveProjectTestCaseCategories(projectId: string, categories: String[]) {
    return this.rest.post("saveProjectTestCaseCategories", categories, projectId);
  }

  addNewTestCase(testAutomationId: string, testCase: TestAutomationCase) {
    return this.rest.put("addTestCase", testCase, testAutomationId);
  }

  updateTestCase(testCase: TestAutomationCase) {
    return this.rest.put("updateTestCase", testCase);
  }

  deleteTestCase(testAutomationId: string, testCaseId: string) {
    return this.rest.delete("deleteTestCase", testAutomationId, testCaseId);
  }

  deleteSelectedTestCases(payload: { ids: string[], isDB2: boolean }) {
    return this.rest.deleteWithPayload("deleteTestCases", payload, null, null);
  }

  runSelectedTestCases(execution: any, testCaseIds: string[], isDB2: boolean = false) {
    let request: any = {
      ids: testCaseIds,
      execution: execution
    };

    // If running against DB2 include the flag and project id from localStorage
    if (isDB2) {
      request.isDB2 = true;
      const projectIdDb2 = localStorage.getItem('projectIdDb2');
      if (projectIdDb2) {
        request.project = { _id: projectIdDb2 };
      }
    }

    return this.rest.post("runSelectedTestCases", request, null);
  }

  executeScript(testCaseId: string, testCase: TestAutomationCase) {
    // const formData: FormData = new FormData();
    // formData.append('file',  new Blob(), '');

    // let request = {
    //   project: {
    //     _id: { $oid: testCase.project_id } // Assuming this is available in testCase
    //   },
    //   execution: {
    //     resolution: "1920x1200",
    //     browser: ["Chrome"],
    //     default_pause: "0",
    //     screenshot_required: false,
    //     default_hub: true,
    //     local_execution: false,
    //     suite_id: testCase.suite_id, // Assuming this is available in testCase
    //     send_mail: false,
    //     hub_ip: "",
    //     execution_machine: "Default Machine",
    //     port: 4445
    //   },
    //   csv: testCase.dataset_link,
    //   test_case_id: testCaseId
    // };
    // formData.append('req', JSON.stringify(request));
    // let apiRequestOptions: ApiRequestOptions = {};
    // apiRequestOptions.body = formData;
    // apiRequestOptions.headers = { "Accept": "application/json" };

    // let requestKey = "executeSuite";
    // if (testCase.suite_dbName === "db2") {
    //   requestKey = "executeSuitedb2";
    // }

    return this.rest.post("executeSuite", null);
  }

  uploadTestcaseCsvFile(file: File, testCaseId: string) {
    const formData = new FormData();
    formData.append('file', file);

    return this.rest.post("uploadTestcaseCsvFile", formData, testCaseId);
  }

  generateTestCases(payload: any) {
    return this.rest.post("generateTestCases", payload);
  }

  generateTestCaseAutomation(payload: any) {
    return this.rest.post("generateTestCaseAutomation", payload);
  }

  public generatedTestCase(reportID): Observable<any> {
    return this.rest.get('generatedTestCase', reportID);
  }

  public saveToLibraryTestCases(payload: any): Observable<any> {
    const projectId = localStorage.getItem(Literals.projectId);
    payload.project = { _id: projectId };
    return this.rest.post("saveToLibraryTestCases", payload);
  }
}
